export enum QuantityUnitsEnum {
    item = "ITEM",
    //...
}
